<template>
  <PageView
    :application="application"
    class="with-submenu"
  >
    <SubMenu
      :aria-label="$t('menu.aria-sub-menu')"
      :paths="subMenuPaths"
      :root="application.localName || application.name"
      role="navigation"
    />
    <TitleAndDescription
      :application="application"
      :local-title="
        $t('titles.data-type-authorizations', {
          dataType: application.localName || application.name,
          type: 'autorisation'
        })
      "
      :local-description="application.localRefDescription"
      :local-name="application.localName || application.name"
    />
    <div class="contentView">
      <div class="rows">
        <div class="row">
          <div class="columns data-auth-view">
            <div class="column is-8">
              <b-field class="btn_radio_auth">
                <b-select
                  v-model="showTableBy"
                  icon="table-list"
                  rounded
                  @update:model-value="updateTableAuthorizations"
                >
                  <option
                    value="2"
                    :aria-label="$t('dataTypeAuthorizations.table-auth-name')"
                  >
                    {{ "🔑" }} {{ $t("dataTypeAuthorizations.table-auth-name") }}
                  </option>
                  <option
                    value="1"
                    :aria-label="$t('dataTypeAuthorizations.table-auth-users')"
                  >
                    {{ "👥" }} {{ $t("dataTypeAuthorizations.table-auth-users") }}
                  </option>
                  <option
                    v-if="listAuthorizationsByPublic.length !== 0"
                    value="3"
                    :aria-label="$t('dataTypeAuthorizations.table-auth-public')"
                  >
                    {{ "🔓" }} {{ $t("dataTypeAuthorizations.table-auth-public") }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div
              v-if="isApplicationManager"
              class="column is-offset-1 is-3"
            >
              <b-button
                expanded
                icon-left="plus"
                type="is-dark is-right"
                :aria-label="$t('dataTypeAuthorizations.add-auhtorization')"
                @click="addAuthorization"
              >
                {{ $t("dataTypeAuthorizations.add-auhtorization") }}
              </b-button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="columns data-auth-view">
            <div class="column is-2">
              <b-radio
                v-if="hasAuthorizationsByUsers"
                v-model="filterAuthByUsers"
                name="show_users_auth_mode"
                native-value="userWithoutAuth"
                :aria-label="$t('dataTypeAuthorizations.table-auth-users-without-auth')"
                @input="displayUsersBasedOnAuth($event)"
              >
                {{ $t("dataTypeAuthorizations.table-auth-users-without-auth") }}
              </b-radio>
            </div>
            <div class="column is-2">
              <b-radio
                v-if="hasAuthorizationsByUsers"
                v-model="filterAuthByUsers"
                name="show_users_auth_mode"
                native-value="userWithAuth"
                :aria-label="$t('dataTypeAuthorizations.table-auth-users-with-auth')"
                @input="displayUsersBasedOnAuth($event)"
              >
                {{ $t("dataTypeAuthorizations.table-auth-users-with-auth") }}
              </b-radio>
            </div>
            <div class="column is-2">
              <b-radio
                v-if="hasAuthorizationsByUsers"
                v-model="filterAuthByUsers"
                name="show_users_auth_mode"
                native-value="allUsers"
                :aria-label="$t('dataTypeAuthorizations.table-auth-users-all-user')"
                @input="displayUsersBasedOnAuth($event)"
              >
                {{ $t("dataTypeAuthorizations.table-auth-users-all-user") }}
              </b-radio>
            </div>
            <div
              v-if="isApplicationManager && listAuthorizationsByPublic.length === 0"
              class="column is-offset-3 is-3"
            >
              <b-button
                expanded
                icon-left="table-cells-row-unlock"
                outlined
                type="is-warning is-right"
                :aria-label="$t('dataTypeAuthorizations.add-public-auhtorization')"
                @click="addPublicAuthorization()"
              >
                {{ $t("dataTypeAuthorizations.add-public-auhtorization") }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <LoadingAnimate
        v-if="isLoading"
        :size="'is-large'"
      />
      <div
        v-else
        class="columns"
      >
        <!-- table des autorisations par nom d'utilisateur -->
        <b-table
          v-if="hasAuthorizationsByUsers"
          :aria-current-label="$t('menu.aria-curent-page')"
          :aria-label="$t('menu.aria-pagination')"
          :aria-next-label="$t('menu.aria-next-page')"
          :aria-previous-label="$t('menu.aria-previous-page')"
          :data="listAuthorizationsByUsersBasedOnAuth"
          :height="tableHeight.listAuthorizationsByUsersBasedOnAuth"
          :paginated="listAuthorizationsByUsersBasedOnAuth.length > 20"
          :striped="true"
          :total="authorizationLength"
          class="column table-auth"
          default-sort="row.name"
          default-sort-direction="asc"
          sort-icon="arrow-up"
          sort-icon-size="is-small"
          sortable
        >
          <!--        <template #pagination>
            <b-pagination
              v-model="currentPage"
              :aria-current-label="$t('menu.aria-curent-page')"
              :aria-label="$t('menu.aria-pagination')"
              :aria-next-label="$t('menu.aria-next-page')"
              :aria-previous-label="$t('menu.aria-previous-page')"
              :current-page.sync="currentPage"
              :per-page="perPage"
              :rounded="true"
              :total="authorizationLength"
              order="is-centered"
              range-after="3"
              range-before="3"
              role="navigation"
              @change="changePage"
            />
          </template>-->
          <b-table-column
            :label="$t('referencesAuthorizations.user-name')"
            :aria-label="$t('referencesAuthorizations.user-name')"
            :searchable="true"
            field="name"
            sortable
          >
            <template #searchable="props">
              <b-input
                v-model="props.filters[props.column.field]"
                :placeholder="$t('dataTypeAuthorizations.search')"
                :aria-label="$t('dataTypeAuthorizations.search')"
                icon="search"
              />
            </template>
            <template #default="props">
              <p
                class="card-header-title"
                :aria-label="props.row.name"
              >
                {{ props.row.name }}
              </p>
            </template>
          </b-table-column>
          <b-table-column
            :label="$t('referencesAuthorizations.user-email')"
            :aria-label="$t('referencesAuthorizations.user-email')"
            :searchable="true"
            field="email"
            sortable
          >
            <template #searchable="props">
              <b-input
                v-model="props.filters[props.column.field]"
                :placeholder="$t('dataTypeAuthorizations.search')"
                :aria-label="$t('dataTypeAuthorizations.search')"
                icon="search"
              />
            </template>
            <template #default="props">
              <p
                class="card-header-title"
                :aria-label="props.row.email"
              >
                {{ props.row.email }}
              </p>
            </template>
          </b-table-column>
          <b-table-column
            v-slot="props"
            :label="$t('dataTypeAuthorizations.name')"
            :aria-label="$t('dataTypeAuthorizations.name')"
            field="auth"
            sortable
            width="60vh"
          >
            <b-collapse
              :model-value="openListAuthName"
              animation="slide"
              aria-id="list-auths"
              class="collapse styleCollapseInTable"
            >
              <template #trigger="detail">
                <div
                  :aria-expanded="!detail.open"
                  aria-controls="list-auths"
                  class="card-header styleCollapseInTable"
                >
                  <p
                    class="card-header-title"
                    :aria-label="$t('dataTypeAuthorizations.list-auths', {
                      numberAuths: props.row?.auth
                        ? props.row.auth.map((auth: any) => auth.id).length
                        : 0,
                    })"
                  >
                    {{
                      $t("dataTypeAuthorizations.list-auths", {
                        numberAuths: props.row?.auth
                          ? props.row.auth.map((auth: any) => auth.id).length
                          : 0,
                      })
                    }}
                  </p>
                  <a
                    :tabindex="hasAuthorizationsByUsers ? 0 : -1"
                    class="card-header-icon"
                    :aria-label="$t('dataTypeAuthorizations.showMore')"
                    @keyup.enter="openListAuthName = !openListAuthName"
                    @keyup.space="openListAuthName = !openListAuthName"
                  >
                    <b-tooltip
                      :label="$t('dataTypeAuthorizations.showMore')"
                      position="is-left"
                    >
                      <b-icon
                        :icon="detail.open ? 'chevron-up' : 'chevron-down'"
                        type="is-primary"
                      />
                    </b-tooltip>
                  </a>
                </div>
              </template>
              <div class="card-content">
                <div class="content">
                  <b-field
                    :label="$t('dataTypeAuthorizations.filter-auth-by-name')"
                    :aria-label="$t('dataTypeAuthorizations.filter-auth-by-name')"
                    class="columns"
                  >
                    <b-input
                      :placeholder="$t('dataTypeAuthorizations.search')"
                      :aria-label="$t('dataTypeAuthorizations.search')"
                      icon="search"
                      @input="filterListAuthName(listAuthorizations, $event)"
                    />
                  </b-field>
                  <div class="columns is-multiline">
                    <ListAuthorisation
                      :lang="lang"
                      :result-filter-auth-by-name="resultFilterAuthByName"
                      :checkbox="checkbox"
                      :row="props.row"
                      :list-column-name="listColumnName"
                      :is-user-manager="isUserManager"
                      :application="application"
                      :update-list-users-in-authorization="updateListUsersInAuthorization"
                    />
                  </div>
                </div>
              </div>
            </b-collapse>
          </b-table-column>
        </b-table>
        <!-- table des autorisations par nom d'autorisation -->
        <b-table
          v-else
          :aria-current-label="$t('menu.aria-curent-page')"
          :aria-label="$t('menu.aria-pagination')"
          :aria-next-label="$t('menu.aria-next-page')"
          :aria-previous-label="$t('menu.aria-previous-page')"
          :data="filteredAuthorizations"
          :height="tableHeight.authorizations"
          :paginated="filteredAuthorizations.length > 20"
          :striped="true"
          :total="filteredAuthorizations.length"
          class="column table-auth"
          default-sort="row.name"
          default-sort-direction="asc"
          sort-icon="arrow-up"
          sort-icon-size="is-small"
          sortable
        >
          <!--        <template #pagination>
            <b-pagination
              v-model="currentPage"
              :aria-current-label="$t('menu.aria-curent-page')"
              :aria-label="$t('menu.aria-pagination')"
              :aria-next-label="$t('menu.aria-next-page')"
              :aria-previous-label="$t('menu.aria-previous-page')"
              :current-page.sync="currentPage"
              :per-page="perPage"
              :rounded="true"
              :total="authorizationLength"
              order="is-centered"
              range-after="3"
              range-before="3"
              role="navigation"
              @change="changePage"
            />
          </template>-->
          <b-table-column
            :label="$t('dataTypeAuthorizations.name')"
            :aria-label="$t('dataTypeAuthorizations.name')"
            :searchable="true"
            field="name"
            sortable
          >
            <template #searchable>
              <b-input
                v-model="nameSearch"
                :placeholder="$t('dataTypeAuthorizations.search')"
                :aria-label="$t('dataTypeAuthorizations.search')"
                icon="search"
              />
            </template>
            <template #default="props">
              <b-collapse
                :model-value="openAuthName"
                animation="slide"
                aria-id="auths-name"
                class="collapse styleCollapseInTable"
              >
                <template #trigger="detail">
                  <div
                    aria-controls="auths-name"
                    class="card-header styleCollapseInTable"
                  >
                    <a class="card-header-icon">
                      <b-button
                        :disabled="!isApplicationManager"
                        class="btnShowAuth"
                        icon-left="times-circle"
                        size="is-small"
                        type="is-danger is-light"
                        @click="revoke(props.row.uuid)"
                      />
                      <b-button
                        :disabled="!isApplicationManager"
                        class="btnShowAuth"
                        icon-left="pen-square"
                        onmouseout="style.color='';"
                        onmouseover="style.color='rgba(255,140,0,0.5)'"
                        outlined
                        size="is-small"
                        type="is-warning"
                        @click="modifyAuthorization(props.row.uuid)"
                      />
                    </a>
                    <p class="card-header-title">
                      <TitleCardWithLimitLength
                        :limit="35"
                        :local-name="props.row.name"
                        position="is-right"
                      />
                    </p>
                    <a
                      class="card-header-icon"
                      tabindex="0"
                      @keyup.enter="openAuthName = !openAuthName"
                      @keyup.space="openAuthName = !openAuthName"
                    >
                      <b-tooltip
                        :label="$t('dataTypeAuthorizations.showMore')"
                        :aria-label="$t('dataTypeAuthorizations.showMore')"
                        position="is-left"
                      >
                        <b-icon
                          :icon="detail.open ? 'chevron-up' : 'chevron-down'"
                          type="is-primary"
                        />
                      </b-tooltip>
                    </a>
                  </div>
                </template>
                <div class="card-content">
                  <div class="content">
                    <div class="columns">
                      <p>
                        <strong :aria-label="$t('applications.comment')">{{ $t("applications.comment") }}</strong>
                        <small :aria-label="props.row.description">{{ props.row.description }}</small>
                      </p>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </template>
          </b-table-column>
          <b-table-column
            v-if="!hasPublicAuthorizations"
            :label="$t('dataTypeAuthorizations.users')"
            :aria-label="$t('dataTypeAuthorizations.users')"
            field="users"
            sortable
          >
            <template #default="props">
              <b-collapse
                :model-value="openListUserName"
                animation="slide"
                aria-id="list-users"
                class="collapse styleCollapseInTable"
              >
                <template #trigger="detail">
                  <div
                    :aria-expanded="!detail.open"
                    aria-controls="list-users"
                    class="card-header styleCollapseInTable"
                  >
                    <p
                      class="card-header-title"
                      :aria-label="authorizationUsersLabel(props.row)"
                    >
                      {{ authorizationUsersLabel(props.row) }}
                    </p>
                    <a
                      :tabindex="!hasAuthorizationsByUsers ? 0 : -1"
                      class="card-header-icon"
                      @keyup.enter="openListUserName = !openListUserName"
                      @keyup.space="openListUserName = !openListUserName"
                    >
                      <b-tooltip
                        :label="$t('dataTypeAuthorizations.showMore')"
                        :aria-label="$t('dataTypeAuthorizations.showMore')"
                        position="is-left"
                      >
                        <b-icon
                          :icon="detail.open ? 'chevron-up' : 'chevron-down'"
                          type="is-primary"
                        />
                      </b-tooltip>
                    </a>
                  </div>
                </template>
                <div class="card-content">
                  <div class="content">
                    <b-field
                      :label="$t('dataTypeAuthorizations.filter-user-by-name')"
                      :aria-label="$t('dataTypeAuthorizations.filter-user-by-name')"
                      class="columns"
                    >
                      <b-input
                        :placeholder="$t('dataTypeAuthorizations.search')"
                        :aria-label="$t('dataTypeAuthorizations.search')"
                        icon="search"
                        @input="filterListUserName(listUsersHasSignedCharter, $event)"
                      />
                    </b-field>
                    <div class="columns is-multiline">
                      <b-field
                        v-for="user in resultFilterUsersByName"
                        :key="user.id"
                        class="column is-4"
                      >
                        <!--
                          Ticket #521 - Bug #5 : badge UI pour les utilisateurs
                          qui sont deja {@code applicationManager} ou
                          {@code userManager} de l'application . Pour ces
                          utilisateurs , les autorisations detaillees ( par
                          datatype/ref avec extraction/depot/delete ) sont
                          silencieusement override par leur role de
                          gestionnaire ( ils ont deja tous les droits via
                          RLS ) . On les marque visuellement + tooltip pour
                          eviter la confusion de l'utilisateur qui penserait
                          restreindre leurs droits via l'autorisation .
                        -->
                        <span
                          :class="{ 'user-is-already-manager': user.isApplicationManager || user.isUserManager }"
                          :title="user.isApplicationManager || user.isUserManager
                            ? $t('dataTypeAuthorizations.user-already-manager-tooltip')
                            : ''"
                        >
                          <b-checkbox
                            v-model="checkbox[props.row.name + '_' + user.label]"
                            :aria-label="user.id +': '+ checkbox[props.row.name + '_' + user.label]"
                            :disabled="
                              (props?.row?.users || []).map((use: any) => use.login).length === 1 &&
                                checkbox[props.row.name + '_' + user.label] === true &&
                                (isApplicationManager || isUserManager)
                            "
                            @update:model-value="updateListUsersInAuthorization(props.row, user.label)"
                          >
                            <TitleCardWithLimitLength
                              :limit="8"
                              :local-name="user.label"
                            />
                            <span
                              v-if="user.isApplicationManager || user.isUserManager"
                              class="manager-badge"
                              :title="$t('dataTypeAuthorizations.user-already-manager-tooltip')"
                            >
                              ★
                            </span>
                          </b-checkbox>
                        </span>
                      </b-field>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </template>
          </b-table-column>
          <b-table-column
            :label="$t('dataTypeAuthorizations.data')"
            :aria-label="$t('dataTypeAuthorizations.data')"
            field="authorizations"
            sortable
            width="35vh"
          >
            <template #default="props">
              <b-collapse
                :model-value="openListAuthScope"
                animation="slide"
                aria-id="list-privileges"
                class="collapse styleCollapseInTable"
              >
                <template #trigger="detail">
                  <div
                    :aria-expanded="!detail.open"
                    aria-controls="list-privileges"
                    class="card-header styleCollapseInTable"
                  >
                    <!--
                      Ticket #521 ( option C ) : on masque les dépendances
                      RLS auto-injectées par le backend
                      ( {@code addDependantAuthorizations} ) , de sorte que
                      l'utilisateur voit ici uniquement ce qu'il a coché
                      lui-même - aligné avec l'écran d'édition .
                    -->
                    <p
                      class="card-header-title"
                      :aria-label="$t('dataTypeAuthorizations.list-privileges', {
                        numberPrivileges: Object.keys(filterVisibleAuthorizations(props.row.authorizations, application.dependantNodesByDataName)).length,
                      })"
                    >
                      {{
                        $t("dataTypeAuthorizations.list-privileges", {
                          numberPrivileges: Object.keys(filterVisibleAuthorizations(props.row.authorizations, application.dependantNodesByDataName)).length,
                        })
                      }}
                    </p>
                    <a
                      :tabindex="!hasAuthorizationsByUsers ? 0 : -1"
                      class="card-header-icon"
                      @keyup.enter="openListAuthScope = !openListAuthScope"
                      @keyup.space="openListAuthScope = !openListAuthScope"
                    >
                      <b-tooltip
                        :label="$t('dataTypeAuthorizations.showMore')"
                        :aria-label="$t('dataTypeAuthorizations.showMore')"
                        position="is-left"
                      >
                        <b-icon
                          :icon="detail.open ? 'chevron-up' : 'chevron-down'"
                          type="is-primary"
                        />
                      </b-tooltip>
                    </a>
                  </div>
                </template>
                <div class="card-content">
                  <div class="content">
                    <div class="columns">
                      <SummaryTableOfAuthorizationByData
                        :application="application"
                        :authorization="filterVisibleAuthorizations(props.row.authorizations, application.dependantNodesByDataName)"
                        :list-column-name="listColumnName"
                        @show-more="modifyAuthorization(props.row.uuid)"
                      />
                    </div>
                  </div>
                </div>
              </b-collapse>
            </template>
          </b-table-column>
        </b-table>
      </div>
    </div>
  </PageView>
</template>

<script lang="ts">
// ─────────────────────────────────────────────────────────────────────────────
// DataTypeAuthorizationsView.vue — vue allégée
// Toute la logique métier est dans
// @/composable/authorization/useDataTypeAuthorizations.ts
// ─────────────────────────────────────────────────────────────────────────────
import SubMenu from "@/components/common/SubMenu.vue";
import PageView from "../../common/PageView.vue";
import LoadingAnimate from "@/components/common/LoadingAnimate.vue";
import TitleAndDescription from "@/components/common/TitleAndDescription.vue";
import DetailAuthorizationModalCard from "@/components/common/authorization/DetailAuthorizationModalCard.vue";
import SummaryTableOfAuthorizationByData from "@/components/common/authorization/SummaryTableOfAuthorizationByData.vue";
import { filterVisibleAuthorizations } from "@/composable/authorization/useAuthorizationDependencyFilter";
import { computeAuthorizationUserCounts } from "@/composable/authorization/authorizationUserCount";
import { useI18n } from "vue-i18n";
import TitleCardWithLimitLength from "@/components/common/TitleCardWithLimitLength.vue";
import "@/style/views/authorization/data/DataTypeAuthorizationsView.scss";
import {
  BButton, BCheckbox, BCollapse, BField, BIcon, BInput, BModal,
  BRadio, BSelect, BTable, BTableColumn, BTooltip,
} from "buefy";
import { useDataTypeAuthorizations } from "@/composable/authorization/useDataTypeAuthorizations";
import services from "@/composable/services";
import ListAuthorisation from "@/components/common/authorization/ListAuthorisation.vue";
import { useRoute } from "vue-router";
import { computed, ref } from "vue";
import type { GetAuthorizationResult } from "@/types/generated/UsedGeneratedTypes";

export default {
  name: "DataTypeAuthorizationsView",
  components: {
    ListAuthorisation,
    BModal, BCheckbox, BCollapse, BInput, BTableColumn, BTable,
    BRadio, BButton, BField, TitleCardWithLimitLength, BTooltip, BIcon, BSelect,
    TitleAndDescription, SummaryTableOfAuthorizationByData, LoadingAnimate,
    PageView, SubMenu, DetailAuthorizationModalCard,
  },
  props: {
    dataTypeId: { type: String, default: "" },
    applicationName: { type: String, required: true },
  },
  setup(props) {
    const composable = useDataTypeAuthorizations(props as { dataTypeId: string; applicationName: string });
    const route = useRoute();

    // Recherche par nom contrôlée localement. Pré-initialisée par le query
    // string `?q=<nom>` ( utilisé notamment par l'icône oeil de la page de
    // traitement d'une demande pour pointer vers une autorisation précise ).
    // On filtre nous-mêmes les données de la table : Buefy déclenche son
    // filtrage interne via l'événement `@input` du b-input et ignore les
    // mutations programmatiques de l'objet `filters`, d'où le contrôle
    // manuel ici. Le visuel ( champ de recherche dans l'en-tête de colonne )
    // reste identique.
    const nameSearch = ref<string>(String(route.query?.q ?? ""));

    function normalize(value: string): string {
      return value.toLowerCase().trim();
    }

    const filteredAuthorizations = computed<GetAuthorizationResult[]>(() => {
      const term = normalize(nameSearch.value);
      const source = composable.authorizations.value as GetAuthorizationResult[];
      if (!term) return source;
      return source.filter(a => normalize(a.name ?? "").includes(term));
    });

    const { t } = useI18n();

    /**
     * Construit le libelle "Liste des utilisateurs : (N) - dont K
     * administrateur(s) masque(s)" pour une autorisation donnee . Le
     * compteur est calcule en live a partir de l'etat reactif des
     * checkboxes ( {@code composable.checkbox} ) , de sorte que cocher
     * / decocher un utilisateur met a jour le total immediatement sans
     * attendre un appel REST .
     *
     * <p>Les administrateurs OpenADOM sont filtres de la liste cochable
     * ( ils ne sont pas {@code isApplicationUser} ) mais peuvent
     * apparaitre dans {@code auth.users} cote BDD . On les decompte
     * separement pour rendre cet etat lisible cote utilisateur ( "(2) -
     * dont 1 administrateur masque" ) .
     */
    function authorizationUsersLabel(row: GetAuthorizationResult): string {
      const counts = computeAuthorizationUserCounts(
        row?.users ?? [],
        composable.resultFilterUsersByName.value as Array<{ label?: string; login?: string }>,
        (key: string) => Boolean((composable.checkbox as Record<string, boolean>)[row?.name + "_" + key]),
      );
      if (counts.hiddenAdmins > 0) {
        return t("dataTypeAuthorizations.list-users-with-admins", {
          numberUsers: counts.total,
          hiddenAdmins: counts.hiddenAdmins,
        });
      }
      return t("dataTypeAuthorizations.list-users", { numberUsers: counts.total });
    }

    return { ...composable, nameSearch, filteredAuthorizations, filterVisibleAuthorizations, authorizationUsersLabel };
  },
  computed: {
    services() { return services; },
  },
};
</script>

<style scoped>
/*
 * Ticket #521 - Bug #5 : style discriminant pour les utilisateurs qui
 * sont déjà gestionnaires de l'application ( applicationManager ou
 * userManager ) . Leurs autorisations détaillées sont silencieusement
 * overridées par leur rôle de gestion ( ils ont déjà tous les droits
 * via RLS ) , l'étoile + le style en italique gris attirent l'attention
 * de l'opérateur qui pourrait sinon penser restreindre leurs droits .
 */
.user-is-already-manager {
  font-style: italic;
  color: #7a7a7a;
}
.manager-badge {
  display: inline-block;
  margin-left: 0.25rem;
  color: #ffd166;
  font-size: 0.95em;
  cursor: help;
}
</style>
